import React from "react";

import { Album, Track } from "@music/models";

interface Props {
    entity: Album | Track;
}

export const Copyright = ({ entity }: Props) => (
    <div className="copyright">
        {entity.copyrightSound &&
            <div>&#8471; {entity.copyrightSoundYear} {entity.copyrightSound}</div>
        }
        {entity instanceof Album && entity.copyrightArtwork &&
            <div>&copy; {entity.copyrightArtworkYear} {entity.copyrightArtwork}</div>
        }
    </div>
);
